import type { TAdditionalDataFormFields, TCreditFormCommonFields } from 'entities/creditForm';

export const getAdditionalDataStepLabel = (
  formFields: TAdditionalDataFormFields,
  formFieldsLabels: Partial<Record<keyof TCreditFormCommonFields, string>>,
  stepFields: Array<keyof TAdditionalDataFormFields>,
) =>
  stepFields.map((key) => {
    switch (key) {
      case 'education':
      case 'maritalStatus':
      case 'numberOfDependents': {
        return {
          fieldLabel: String(formFieldsLabels[key]),
          fieldValue: String(formFields[key]?.label),
        };
      }
      default: {
        return {
          fieldLabel: String(formFieldsLabels[key]),
          fieldValue: String(formFields[key]),
        };
      }
    }
  });
